export function fieldTypeAfterPlacement (type, sticky) {
  return sticky ? type : ''
}

export function canPlaceUnboundField (type) {
  return Boolean(type)
}

export function rememberFieldSize (sizes, type, area) {
  if (type && area?.w > 0 && area?.h > 0) {
    sizes[type] = { w: area.w, h: area.h }
  }
}

export function applyRememberedFieldSize (area, type, sizes) {
  const size = sizes[type]

  if (!size) {
    return false
  }

  area.w = size.w
  area.h = size.h

  return true
}

export function isAccidentalMicroDrag (
  area,
  pageWidth,
  pageHeight,
  minimumPixels = 8
) {
  return (
    area.w * pageWidth < minimumPixels ||
    area.h * pageHeight < minimumPixels
  )
}
